import React from 'react';
import { useStore } from '@/store';

export function AgentBanner() {
  const agentOverride = useStore((s) => s.agentOverride);
  const clearAgentOverride = useStore((s) => s.clearAgentOverride);

  if (!agentOverride?.message) return null;

  return (
    <div className="bg-brand-900/30 border-b border-brand-700/40 px-4 py-3 flex items-start gap-3">
      <span className="text-brand-400 text-base shrink-0 mt-0.5">◈</span>
      <div className="flex-1">
        <p className="text-xs font-semibold text-brand-400 uppercase tracking-wide">Agent Message</p>
        <p className="text-sm text-gray-200 mt-0.5">{agentOverride.message}</p>
      </div>
      <button
        onClick={clearAgentOverride}
        className="text-gray-500 hover:text-gray-300 text-lg leading-none shrink-0 transition-colors"
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
}
